import React from 'react';
import { Box } from '../../../../base/Box/Box';
import Link from '../../../../base/Link/Link';
import { MultilinkStoryblok } from '../../../../types/storyblok';

type Props = {
  button: {
    link: MultilinkStoryblok;
    label: string;
  };
};

export const FinalButton = ({ button }: Props) => (
  <Box as="div" className="p-7">
    <Link variant="primary" link={button.link}>
      {button.label}
    </Link>
  </Box>
);
